import React, { useEffect, useState } from "react";

const STAGGER_MS = 90;
const BRACKET_MS = 560;
const TAIL_MS = 220;
const BASE_DELAY_MS = 0;

export const PAGE_ASSEMBLY_OVERLAY_CSS = `
	@keyframes er-page-build-bracket {
		0%   { opacity: 0; transform: translate3d(var(--er-bx, 0px), var(--er-by, 0px), 0); }
		30%  { opacity: 0.95; transform: translate3d(0, 0, 0); }
		68%  { opacity: 0.95; }
		100% { opacity: 0; transform: translate3d(0, 0, 0); }
	}
	.er-build-overlay {
		position: absolute;
		inset: 0;
		pointer-events: none !important;
		z-index: 840;
		overflow: hidden;
	}
	.er-build-guides,
	.er-build-corner {
		pointer-events: none !important;
	}
	.er-build-guides { position: absolute; }
	.er-build-corner {
		position: absolute;
		width: 12px;
		height: 12px;
		border: 0 solid rgba(255, 255, 255, 0.92);
		filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.55));
		opacity: 0;
		animation: er-page-build-bracket 560ms cubic-bezier(0.16, 1, 0.3, 1) both;
		animation-delay: var(--er-build-delay, 0ms);
	}
	.er-build-corner--tl { top: -3px; left: -3px; border-top-width: 2px; border-left-width: 2px; --er-bx: -7px; --er-by: -7px; }
	.er-build-corner--tr { top: -3px; right: -3px; border-top-width: 2px; border-right-width: 2px; --er-bx: 7px; --er-by: -7px; }
	.er-build-corner--bl { bottom: -3px; left: -3px; border-bottom-width: 2px; border-left-width: 2px; --er-bx: -7px; --er-by: 7px; }
	.er-build-corner--br { bottom: -3px; right: -3px; border-bottom-width: 2px; border-right-width: 2px; --er-bx: 7px; --er-by: 7px; }
	@media (prefers-reduced-motion: reduce) {
		.er-build-overlay { display: none; }
	}
`;

/**
 * Guías de encaje ancladas a layoutItems (coords del canvas).
 * Sin nodos fantasma en el DOM de juego: no interceptan clics.
 * Se autodesmonta al terminar la animación.
 */
export default function EscapeRoomPageAssemblyOverlay({
	layoutItems,
	staggerMs = STAGGER_MS,
	maxItems = 8,
	overlayKey,
	onDone,
}) {
	const [rects, setRects] = useState([]);
	const [alive, setAlive] = useState(true);

	useEffect(() => {
		setAlive(true);
		const next =
			Array.isArray(layoutItems) && layoutItems.length
				? layoutItems.slice(0, maxItems).map((it) => ({
						top: Number(it.top ?? it.y) || 0,
						left: Number(it.left ?? it.x) || 0,
						width: Math.max(1, Number(it.width) || 0),
						height: Math.max(1, Number(it.height) || 0),
					}))
				: [];
		setRects(next);

		const n = Math.max(next.length, 1);
		const total = staggerMs * Math.max(n - 1, 0) + BRACKET_MS + TAIL_MS + BASE_DELAY_MS;
		const t = setTimeout(() => {
			setAlive(false);
			onDone?.();
		}, total);
		return () => clearTimeout(t);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [overlayKey]);

	if (!alive || !rects.length) return null;

	return (
		<>
			<style>{PAGE_ASSEMBLY_OVERLAY_CSS}</style>
			<div key={overlayKey || "assembly"} className="er-build-overlay" aria-hidden>
				{rects.map((r, i) => (
					<div
						key={i}
						className="er-build-guides"
						style={{
							top: r.top,
							left: r.left,
							width: r.width,
							height: r.height,
							"--er-build-delay": `${BASE_DELAY_MS + i * staggerMs}ms`,
						}}
					>
						<span className="er-build-corner er-build-corner--tl" />
						<span className="er-build-corner er-build-corner--tr" />
						<span className="er-build-corner er-build-corner--bl" />
						<span className="er-build-corner er-build-corner--br" />
					</div>
				))}
			</div>
		</>
	);
}
